module.exports = __webpack_public_path__ + "assets/img/sarah-min.71084685.jpeg";